export class GlobalConst {
    public static readonly PROPERTIES_URL = 'assets/properties.json'
}